import { render, staticRenderFns } from "./__ProductCart.vue?vue&type=template&id=4b3da46c"
import script from "./__ProductCart.vue?vue&type=script&lang=js"
export * from "./__ProductCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports